import { create } from "zustand";
import { getPyamentsDashboard } from "../api";

export const usePyamentsDashboard = create((set) => ({
    pyamentsDashboardData: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
    fetchPaymentsDashboard: async (payload) => {
      set({ errorMessage: "", isError: false });
      set({ isLoading: true });
      try {
        const response = await getPyamentsDashboard(payload);
        set({ pyamentsDashboardData: response.data, isLoading: false });
      } catch (error) {
        set({
          errorMessage: error?.response?.data?.Error,
          isError: true,
          isLoading: false,
        });
      }
    },
  }));

  export const usePyamentsDashboardTable = create((set) => ({
    pyamentsDashboardTableData: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
    fetchPaymentsDashboardTable: async (payload) => {
      set({ errorMessage: "", isError: false });
      set({ isLoading: true });
      try {
        const response = await getPyamentsDashboard(payload);
        set({ pyamentsDashboardTableData: response.data, isLoading: false });
      } catch (error) {
        set({
          errorMessage: error?.response?.data?.Error,
          isError: true,
          isLoading: false,
        });
      }
    },
  }));

  export const usePyamentsHourlyDashboard = create((set) => ({
    pyamentsDashboardData: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
    fetchPaymentsHourlyDashboard: async (payload) => {
      set({ errorMessage: "", isError: false });
      set({ isLoading: true });
      try {
        const response = await getPyamentsDashboard(payload);
        set({ pyamentsDashboardData: response.data, isLoading: false });
      } catch (error) {
        set({
          errorMessage: error?.response?.data?.Error,
          isError: true,
          isLoading: false,
        });
      }
    },
  }));